import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import {
  Typography,
  Grid,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import { stockAPI } from "../../../common/axiosInstance";
import { apiData, headerScreenLabels } from "../../../common/common-types";
import Header from "../../../components/Layout/Header/HeaderSubmitBill";
import AlertMessage from "../../../common/AlertMessage/AlertMessage";
import MyRoute from "../../../hoc/MyRoute";
import green_tick from '../../../assets/icons/bill_upload_guidelines/green_tick.png';
import red_tick from '../../../assets/icons/bill_upload_guidelines/red_cross.png';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(5),
    textAlign: "center",
  },
  section: {
    marginBottom: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: "500px",
    margin: "0 auto",
  },
  textContainer: {
    width: "100%",
    maxWidth: "400px",
    margin: "0 auto",
    textAlign: "left",
  },
  title: {
    fontSize: "18px",
    fontWeight: "600",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  label: {
    fontWeight: "bold",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    color: "#000000",
    display: "inline",
  },
  value: {
    marginBottom: `${theme.spacing(1)}px !important`,
    fontSize: "16px",
    color: "#000000",
    display: "inline",
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 300,
  },
  error: {
    color: theme.palette.error.main,
    textAlign: "center",
    padding: theme.spacing(3),
  },
  imageContainer: {
    marginBottom: "30px",
    display: "inline-block",
    width: "132px",
    height: "132px",
    overflow: "hidden",
    verticalAlign: "top",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
      width: "112px",
      height: "112px",
      verticalAlign: "top",
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: "10px",
      width: "57px",
      height: "57px",
      verticalAlign: "top",
    },
  },
  img: {
    width: "100%",
    height: "100%",
  },
  heading: {
    fontSize: "32px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "0.94",
    letterSpacing: "normal",
    textAlign: "center",
    width: "100%",
    display: "block",
    color: theme.palette.typography.texts.color,
    // marginTop: "120px",
    [theme.breakpoints.down(641)]: {
      fontSize: "28px",
      lineHeight: "0.96",
      // marginTop: "100px",
    },
    [theme.breakpoints.down(481)]: {
      fontSize: "18px",
      lineHeight: "0.91",
      // marginTop: "80px",
    },
    [theme.breakpoints.down(421)]: {
      fontSize: "17.5px",
    },
    [theme.breakpoints.down(401)]: {
      fontSize: "17px",
    },
    [theme.breakpoints.down(381)]: {
      fontSize: "16.5px",
      lineHeight: "0.83",
      // marginTop: "60px",
    },
    [theme.breakpoints.down(361)]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down(321)]: {
      fontSize: "14px",
      lineHeight: "0.84",
      // marginTop: "50px",
    },
  },
});

class CustomerPrivilege extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      privilegeData: null,
    };
  }

  async componentDidMount() {
    await this.fetchPrivilegeDetails();
  }

  fetchPrivilegeDetails = async () => {
    try {
      // Get query parameters from URL
      const queryParams = new URLSearchParams(this.props.location.search);
      const customerId = queryParams.get('customerId');
      const privilegeId = queryParams.get('privilegeId');
      const merchantId = queryParams.get('merchantId');
      const locationId = queryParams.get('locId');
      const productsMerchantId = queryParams.get('productId');
      const privilegeType = queryParams.get('privilegeType');
      const shopId = queryParams.get('shopId');
      // Check if required parameters are present
      if (!customerId) {
        this.setState({
          loading: false,
          error: "Missing required parameters."
        });
        return;
      }
      if(privilegeType!=2){
        this.setState({
          loading: false,
          error: "Invalid QR code"
        });
        return;
      }
      // Create payload for API request
      const privilegePayload = new FormData();
      const order_details = [{"product_merchant_id":String(productsMerchantId),"qty":1,"location_id":String(locationId),"best_price":0,"calculated_points":0}]
      privilegePayload.append("kiosk_user_id", 1);
      privilegePayload.append("platform", 3);
      privilegePayload.append("customer_id", customerId);
      privilegePayload.append("privilege_id", privilegeId);
      privilegePayload.append("merchant_id", merchantId);
      privilegePayload.append("order_details", JSON.stringify(order_details));
      privilegePayload.append("shop_id", shopId || 0);
      // Make API request
      const privilegeDetails = await stockAPI(
        privilegePayload,
        "POST",
        "/placeOrder"
      );

      // Update state with the response data
      if (privilegeDetails && !privilegeDetails.error) {
        this.setState({
          loading: false,
          privilegeData: privilegeDetails,
        });
      } else {
        this.setState({
          loading: false,
          error: privilegeDetails?.message || "Failed to fetch privilege details."
        });
      }
    } catch (error) {
      console.error("Error fetching privilege details:", error);
      this.setState({
        loading: false,
        error: "An error occurred while fetching privilege details."
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { loading, error, privilegeData } = this.state;

    let content;

    if (loading) {
      content = (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    } else {
      content = (
        <div className={classes.container}>
          <div className={classes.section}>
            <div style={{ textAlign: "center", width: "100%" }}>
            <div className={classes.imageContainer}>
              <img alt={"success"} src={error?red_tick:green_tick} className={classes.img} />
            </div>
          </div>
          <div className={classes.textContainer} style={{ textAlign: "center", marginBottom: "30px" }}>
            <Typography variant="h4" className={classes.heading}>
              {error ? "Error Placing Order" : "Privilege Details"}
            </Typography>
            <Divider style={{ margin: "20px 0" }} />
            <Typography variant="body1" className={classes.value}>
              {error }
            </Typography>
          </div>
            {!error && <div className={classes.textContainer}>
              <Grid container spacing={2} style={{ marginTop: '0px' }}>
                <Grid item xs={12}>
                  <div>
                    <Typography variant="subtitle1" className={classes.label}>
                      Customer Name:
                    </Typography>
                    <Typography variant="body1" className={classes.value}>
                      {privilegeData?.customer_name || ""}
                    </Typography>
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <div>
                    <Typography variant="subtitle1" className={classes.label}>
                      Privilege Name:
                    </Typography>
                    <Typography variant="body1" className={classes.value}>
                      {privilegeData?.order_privilege_product_details?.[0]?.sub_product_name || ""}
                    </Typography>
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <div>
                    <Typography variant="subtitle1" className={classes.label}>
                      Customer Tier:
                    </Typography>
                    <Typography variant="body1" className={classes.value}>
                      {privilegeData?.tier_name || ""}
                    </Typography>
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <div>
                    <Typography variant="subtitle1" className={classes.label}>
                      Description:
                    </Typography>
                    <Typography variant="body1" className={classes.value}>
                      {privilegeData?.order_privilege_product_details?.[0]?.privilege_name || ""}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>}
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <Header screenLabel={headerScreenLabels.publicPrivilege} />
        <AlertMessage />
        <MyRoute fullHeight={true}>
          {content}
        </MyRoute>
      </Fragment>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(CustomerPrivilege));